import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from "@angular/common/http";
import { EquipmentRequest } from './equipment-request.interface';

@Injectable({
  providedIn: 'root'
})
export class EquipmentRequestService {
  private apiUrl = `${environment.apiConfig.uri}/computer-request`;

  constructor(private http: HttpClient) { }

  createForm(formData: EquipmentRequest): Observable<any> {
    return this.http.post(this.apiUrl, formData)
  }

  updateSection2(formId: string, section2Data: EquipmentRequest['section2']): Observable<any> {
    const url = `${this.apiUrl}/${formId}/section2`;
    return this.http.put(url, { section2: section2Data });
  }

  updateSection3(formId: string, section3Data: EquipmentRequest['section3']): Observable<any> {
    const url = `${this.apiUrl}/${formId}/section3`;
    return this.http.put(url, { section3: section3Data });
  }
    
  updateSection4(formId: string, section4Data: EquipmentRequest['section4']): Observable<any> {
    const url = `${this.apiUrl}/${formId}/section4`;
    return this.http.put(url, { section4: section4Data });
  }
    
  getForm(formId: string): Observable<any> {
    const url = `${this.apiUrl}/${formId}`;
    return this.http.get(url)
  }

  findAllEquipmentRequests(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }
}
